export const ALIGNRIGHT = 'alignRight';